import React from 'react';
export const Demo2 = () => <span>Cos sUI</span>;
